/* 
Created 200 mock positions using Mockaroo (mockaroo.com) 

assetId (Number between 100000-999999 - 6 digits)
ticker (Stock Symbol)
numShares (Number between 0-500)
type (Naughty String - 'STK')
price (Two-Decimal Number between 0-5000)
value (Two-Decimal Value between 0-50000)
date (Within 2021-01-01 and 2021-01-31)

*/

export const POSITIONS = [
  {
    assetId: "13824",
    ticker: "WMT",
    numShares: -100,
    type: "STK",
    price: 147.15,
    value: -14121.0,
    date: "2021-01-31",
  },
  {
    assetId: "365207014",
    ticker: "UBER",
    numShares: 200,
    type: "STK",
    price: 31.1,
    value: 7014.8,
    date: "2021-01-01",
  },
  {
    assetId: "76792991",
    ticker: "TSLA",
    numShares: 50,
    type: "STK",
    price: 281.91,
    value: 18070.64,
    date: "2021-01-01",
  },
  {
    assetId: "273555",
    ticker: "QDEL",
    numShares: -200,
    type: "STK",
    price: 165.05,
    value: -30695.17,
    date: "2021-01-01",
  },
  {
    assetId: "11017",
    ticker: "PEP",
    numShares: 100,
    type: "STK",
    price: 137.89,
    value: 13781.6,
    date: "2021-01-01",
  },
  {
    assetId: 518575,
    ticker: "NADL",
    numShares: 58,
    type: "STK",
    price: 2414.95,
    value: 36747.05,
    date: "2021-01-10",
  },
  {
    assetId: 291482,
    ticker: "CCLP",
    numShares: 410,
    type: "STK",
    price: 3731.19,
    value: 4430.38,
    date: "2021-01-07",
  },
  {
    assetId: 555000,
    ticker: "BGE^B",
    numShares: 428,
    type: "STK",
    price: 2857.92,
    value: 27434.76,
    date: "2021-01-28",
  },
  {
    assetId: 461439,
    ticker: "CLIRW",
    numShares: 446,
    type: "STK",
    price: 3260.68,
    value: 31865.37,
    date: "2021-01-18",
  },
  {
    assetId: 808136,
    ticker: "GGB",
    numShares: 6,
    type: "STK",
    price: 2448.83,
    value: 20009.13,
    date: "2021-01-24",
  },
  {
    assetId: 508623,
    ticker: "COF^P",
    numShares: 68,
    type: "STK",
    price: 1712.67,
    value: 12583.9,
    date: "2021-01-16",
  },
  {
    assetId: 374981,
    ticker: "BLD",
    numShares: 279,
    type: "STK",
    price: 2667.28,
    value: 49459.86,
    date: "2021-01-30",
  },
  {
    assetId: 486480,
    ticker: "LDP",
    numShares: 44,
    type: "STK",
    price: 746.61,
    value: 14288.22,
    date: "2021-01-06",
  },
  {
    assetId: 727291,
    ticker: "BFR",
    numShares: 76,
    type: "STK",
    price: 4316.54,
    value: 21542.48,
    date: "2021-01-13",
  },
  {
    assetId: 884970,
    ticker: "TEDU",
    numShares: 282,
    type: "STK",
    price: 4980.77,
    value: 47256.0,
    date: "2021-01-06",
  },
  {
    assetId: 274574,
    ticker: "TWO",
    numShares: 65,
    type: "STK",
    price: 4708.44,
    value: 17730.37,
    date: "2021-01-29",
  },
  {
    assetId: 831828,
    ticker: "CHT",
    numShares: 241,
    type: "STK",
    price: 3359.6,
    value: 12527.81,
    date: "2021-01-25",
  },
  {
    assetId: 735710,
    ticker: "CDNS",
    numShares: 26,
    type: "STK",
    price: 3641.01,
    value: 17462.1,
    date: "2021-01-09",
  },
  {
    assetId: 804077,
    ticker: "EEFT",
    numShares: 114,
    type: "STK",
    price: 1577.59,
    value: 46856.07,
    date: "2021-01-17",
  },
  {
    assetId: 738294,
    ticker: "WIT",
    numShares: 387,
    type: "STK",
    price: 2302.33,
    value: 26123.44,
    date: "2021-01-29",
  },
  {
    assetId: 549689,
    ticker: "PSEC",
    numShares: 385,
    type: "STK",
    price: 2519.44,
    value: 948.52,
    date: "2021-01-19",
  },
  {
    assetId: 511543,
    ticker: "CASC",
    numShares: 400,
    type: "STK",
    price: 1876.58,
    value: 44674.17,
    date: "2021-01-21",
  },
  {
    assetId: 550117,
    ticker: "ABUS",
    numShares: 476,
    type: "STK",
    price: 4356.38,
    value: 360.72,
    date: "2021-01-24",
  },
  {
    assetId: 295368,
    ticker: "VIPS",
    numShares: 435,
    type: "STK",
    price: 313.6,
    value: 34848.91,
    date: "2021-01-30",
  },
  {
    assetId: 203543,
    ticker: "TAP",
    numShares: 18,
    type: "STK",
    price: 3163.34,
    value: 43232.29,
    date: "2021-01-08",
  },
  {
    assetId: 172801,
    ticker: "UCBI",
    numShares: 289,
    type: "STK",
    price: 320.15,
    value: 23504.9,
    date: "2021-01-28",
  },
  {
    assetId: 830981,
    ticker: "PDT",
    numShares: 268,
    type: "STK",
    price: 3189.74,
    value: 9626.64,
    date: "2021-01-14",
  },
  {
    assetId: 868100,
    ticker: "NGHCO",
    numShares: 104,
    type: "STK",
    price: 3910.36,
    value: 1063.55,
    date: "2021-01-21",
  },
  {
    assetId: 743510,
    ticker: "ETSY",
    numShares: 53,
    type: "STK",
    price: 3218.05,
    value: 48033.65,
    date: "2021-01-20",
  },
  {
    assetId: 226593,
    ticker: "ESV",
    numShares: 385,
    type: "STK",
    price: 3522.71,
    value: 29269.75,
    date: "2021-01-27",
  },
  {
    assetId: 666981,
    ticker: "PGRE",
    numShares: 294,
    type: "STK",
    price: 4069.41,
    value: 23906.73,
    date: "2021-01-29",
  },
  {
    assetId: 530824,
    ticker: "LE",
    numShares: 80,
    type: "STK",
    price: 4059.9,
    value: 24025.76,
    date: "2021-01-02",
  },
  {
    assetId: 334118,
    ticker: "DB",
    numShares: 360,
    type: "STK",
    price: 2418.55,
    value: 13075.19,
    date: "2021-01-05",
  },
  {
    assetId: 270319,
    ticker: "YHOO",
    numShares: 293,
    type: "STK",
    price: 1497.76,
    value: 41971.15,
    date: "2021-01-20",
  },
  {
    assetId: 942070,
    ticker: "CNFR",
    numShares: 89,
    type: "STK",
    price: 1435.02,
    value: 2929.74,
    date: "2021-01-01",
  },
  {
    assetId: 998011,
    ticker: "GAIA",
    numShares: 446,
    type: "STK",
    price: 3013.73,
    value: 23867.76,
    date: "2021-01-29",
  },
  {
    assetId: 866605,
    ticker: "MTN",
    numShares: 27,
    type: "STK",
    price: 1364.34,
    value: 10814.2,
    date: "2021-01-28",
  },
  {
    assetId: 339004,
    ticker: "SBNA",
    numShares: 115,
    type: "STK",
    price: 3717.48,
    value: 24269.09,
    date: "2021-01-26",
  },
  {
    assetId: 547048,
    ticker: "VGM",
    numShares: 389,
    type: "STK",
    price: 3596.03,
    value: 36324.97,
    date: "2021-01-03",
  },
  {
    assetId: 237931,
    ticker: "PYDS",
    numShares: 259,
    type: "STK",
    price: 3229.61,
    value: 30867.31,
    date: "2021-01-11",
  },
  {
    assetId: 997296,
    ticker: "XBIT",
    numShares: 304,
    type: "STK",
    price: 4093.49,
    value: 49837.38,
    date: "2021-01-10",
  },
  {
    assetId: 535635,
    ticker: "MSB",
    numShares: 269,
    type: "STK",
    price: 1720.21,
    value: 42922.89,
    date: "2021-01-17",
  },
  {
    assetId: 437192,
    ticker: "HPS",
    numShares: 93,
    type: "STK",
    price: 3907.78,
    value: 48503.62,
    date: "2021-01-24",
  },
  {
    assetId: 602144,
    ticker: "GDL",
    numShares: 315,
    type: "STK",
    price: 2308.69,
    value: 45209.3,
    date: "2021-01-29",
  },
  {
    assetId: 754935,
    ticker: "TAHO",
    numShares: 448,
    type: "STK",
    price: 1222.91,
    value: 22918.07,
    date: "2021-01-29",
  },
  {
    assetId: 278673,
    ticker: "IPG",
    numShares: 315,
    type: "STK",
    price: 4364.52,
    value: 24216.74,
    date: "2021-01-29",
  },
  {
    assetId: 691414,
    ticker: "NGLS^A",
    numShares: 111,
    type: "STK",
    price: 350.66,
    value: 35041.93,
    date: "2021-01-04",
  },
  {
    assetId: 526948,
    ticker: "LPCN",
    numShares: 176,
    type: "STK",
    price: 1526.18,
    value: 43457.46,
    date: "2021-01-19",
  },
  {
    assetId: 729076,
    ticker: "ITIC",
    numShares: 299,
    type: "STK",
    price: 2224.54,
    value: 33452.66,
    date: "2021-01-21",
  },
  {
    assetId: 502078,
    ticker: "JLL",
    numShares: 66,
    type: "STK",
    price: 2082.23,
    value: 39292.09,
    date: "2021-01-28",
  },
  {
    assetId: 735357,
    ticker: "DLHC",
    numShares: 206,
    type: "STK",
    price: 4145.39,
    value: 31290.45,
    date: "2021-01-23",
  },
  {
    assetId: 242881,
    ticker: "CTG",
    numShares: 24,
    type: "STK",
    price: 675.17,
    value: 17678.61,
    date: "2021-01-09",
  },
  {
    assetId: 971117,
    ticker: "EYEGW",
    numShares: 342,
    type: "STK",
    price: 4413.98,
    value: 46678.2,
    date: "2021-01-10",
  },
  {
    assetId: 910656,
    ticker: "PDM",
    numShares: 359,
    type: "STK",
    price: 2086.93,
    value: 22439.94,
    date: "2021-01-18",
  },
  {
    assetId: 670788,
    ticker: "AEY",
    numShares: 110,
    type: "STK",
    price: 1239.53,
    value: 15914.03,
    date: "2021-01-11",
  },
  {
    assetId: 718627,
    ticker: "GOOS",
    numShares: 299,
    type: "STK",
    price: 292.91,
    value: 26490.67,
    date: "2021-01-04",
  },
  {
    assetId: 263896,
    ticker: "TCP",
    numShares: 216,
    type: "STK",
    price: 176.01,
    value: 24644.0,
    date: "2021-01-05",
  },
  {
    assetId: 699879,
    ticker: "VIRC",
    numShares: 496,
    type: "STK",
    price: 1069.5,
    value: 34552.23,
    date: "2021-01-24",
  },
  {
    assetId: 480055,
    ticker: "HOFT",
    numShares: 248,
    type: "STK",
    price: 3975.69,
    value: 3086.82,
    date: "2021-01-17",
  },
  {
    assetId: 683509,
    ticker: "CXO",
    numShares: 92,
    type: "STK",
    price: 1274.99,
    value: 27922.37,
    date: "2021-01-24",
  },
  {
    assetId: 638969,
    ticker: "BRKS",
    numShares: 417,
    type: "STK",
    price: 1883.86,
    value: 18986.89,
    date: "2021-01-13",
  },
  {
    assetId: 419424,
    ticker: "DCP",
    numShares: 150,
    type: "STK",
    price: 4966.49,
    value: 29934.82,
    date: "2021-01-09",
  },
  {
    assetId: 785149,
    ticker: "ATTU",
    numShares: 410,
    type: "STK",
    price: 246.85,
    value: 24673.78,
    date: "2021-01-19",
  },
  {
    assetId: 330053,
    ticker: "DTUL",
    numShares: 106,
    type: "STK",
    price: 4722.51,
    value: 34783.8,
    date: "2021-01-13",
  },
  {
    assetId: 461573,
    ticker: "KND",
    numShares: 20,
    type: "STK",
    price: 4714.37,
    value: 10520.41,
    date: "2021-01-23",
  },
  {
    assetId: 189867,
    ticker: "MANU",
    numShares: 420,
    type: "STK",
    price: 1025.57,
    value: 4211.51,
    date: "2021-01-06",
  },
  {
    assetId: 297170,
    ticker: "OLN",
    numShares: 316,
    type: "STK",
    price: 2805.72,
    value: 30541.15,
    date: "2021-01-18",
  },
  {
    assetId: 413458,
    ticker: "LORL",
    numShares: 182,
    type: "STK",
    price: 3085.77,
    value: 49522.53,
    date: "2021-01-28",
  },
  {
    assetId: 212655,
    ticker: "CR",
    numShares: 273,
    type: "STK",
    price: 2306.92,
    value: 41529.69,
    date: "2021-01-09",
  },
  {
    assetId: 331053,
    ticker: "CEM",
    numShares: 44,
    type: "STK",
    price: 92.66,
    value: 47868.01,
    date: "2021-01-30",
  },
  {
    assetId: 365462,
    ticker: "CBMXW",
    numShares: 269,
    type: "STK",
    price: 4767.92,
    value: 35159.13,
    date: "2021-01-26",
  },
  {
    assetId: 786689,
    ticker: "ANTH",
    numShares: 401,
    type: "STK",
    price: 3029.87,
    value: 19165.84,
    date: "2021-01-13",
  },
  {
    assetId: 627081,
    ticker: "BW",
    numShares: 244,
    type: "STK",
    price: 867.52,
    value: 1843.58,
    date: "2021-01-05",
  },
  {
    assetId: 687669,
    ticker: "FHK",
    numShares: 383,
    type: "STK",
    price: 845.67,
    value: 22609.46,
    date: "2021-01-23",
  },
  {
    assetId: 103358,
    ticker: "JPM^H",
    numShares: 88,
    type: "STK",
    price: 3862.56,
    value: 20408.4,
    date: "2021-01-10",
  },
  {
    assetId: 913973,
    ticker: "DELTW",
    numShares: 231,
    type: "STK",
    price: 4632.78,
    value: 3362.23,
    date: "2021-01-21",
  },
  {
    assetId: 599223,
    ticker: "MFC",
    numShares: 334,
    type: "STK",
    price: 2359.03,
    value: 44613.06,
    date: "2021-01-26",
  },
  {
    assetId: 978482,
    ticker: "CPRX",
    numShares: 206,
    type: "STK",
    price: 4208.11,
    value: 25303.43,
    date: "2021-01-07",
  },
  {
    assetId: 344013,
    ticker: "SPRT",
    numShares: 455,
    type: "STK",
    price: 3333.8,
    value: 267.96,
    date: "2021-01-01",
  },
  {
    assetId: 698723,
    ticker: "DY",
    numShares: 426,
    type: "STK",
    price: 2627.04,
    value: 34316.94,
    date: "2021-01-29",
  },
  {
    assetId: 705047,
    ticker: "AFT",
    numShares: 496,
    type: "STK",
    price: 3661.62,
    value: 9556.16,
    date: "2021-01-18",
  },
  {
    assetId: 431080,
    ticker: "FSZ",
    numShares: 67,
    type: "STK",
    price: 121.87,
    value: 20539.65,
    date: "2021-01-11",
  },
  {
    assetId: 614537,
    ticker: "ALLT",
    numShares: 307,
    type: "STK",
    price: 3962.95,
    value: 39252.78,
    date: "2021-01-24",
  },
  {
    assetId: 825617,
    ticker: "AFSI^D",
    numShares: 141,
    type: "STK",
    price: 267.61,
    value: 9711.7,
    date: "2021-01-30",
  },
  {
    assetId: 948512,
    ticker: "ALRM",
    numShares: 14,
    type: "STK",
    price: 3783.35,
    value: 35199.92,
    date: "2021-01-28",
  },
  {
    assetId: 246966,
    ticker: "RESN",
    numShares: 164,
    type: "STK",
    price: 3444.76,
    value: 4884.94,
    date: "2021-01-26",
  },
  {
    assetId: 801246,
    ticker: "IMAX",
    numShares: 484,
    type: "STK",
    price: 3874.35,
    value: 22993.8,
    date: "2021-01-16",
  },
  {
    assetId: 203913,
    ticker: "OACQR",
    numShares: 322,
    type: "STK",
    price: 4167.27,
    value: 7273.23,
    date: "2021-01-21",
  },
  {
    assetId: 128964,
    ticker: "PLYA",
    numShares: 281,
    type: "STK",
    price: 2041.98,
    value: 45584.67,
    date: "2021-01-27",
  },
  {
    assetId: 193823,
    ticker: "WFE^A",
    numShares: 106,
    type: "STK",
    price: 4166.07,
    value: 47515.48,
    date: "2021-01-19",
  },
  {
    assetId: 419558,
    ticker: "CIVI",
    numShares: 305,
    type: "STK",
    price: 956.32,
    value: 6372.08,
    date: "2021-01-06",
  },
  {
    assetId: 879624,
    ticker: "BLVD",
    numShares: 142,
    type: "STK",
    price: 3354.64,
    value: 11293.93,
    date: "2021-01-24",
  },
  {
    assetId: 269036,
    ticker: "PDP",
    numShares: 491,
    type: "STK",
    price: 1260.92,
    value: 28586.37,
    date: "2021-01-01",
  },
  {
    assetId: 688420,
    ticker: "LXRX",
    numShares: 75,
    type: "STK",
    price: 4551.72,
    value: 28180.86,
    date: "2021-01-30",
  },
  {
    assetId: 878637,
    ticker: "FF",
    numShares: 31,
    type: "STK",
    price: 4339.7,
    value: 28195.85,
    date: "2021-01-24",
  },
  {
    assetId: 217529,
    ticker: "UL",
    numShares: 102,
    type: "STK",
    price: 3573.94,
    value: 22612.62,
    date: "2021-01-29",
  },
  {
    assetId: 169995,
    ticker: "OASM",
    numShares: 367,
    type: "STK",
    price: 3063.79,
    value: 7083.03,
    date: "2021-01-17",
  },
  {
    assetId: 208217,
    ticker: "PTR",
    numShares: 410,
    type: "STK",
    price: 4331.46,
    value: 1067.04,
    date: "2021-01-23",
  },
  {
    assetId: 213932,
    ticker: "TSRI",
    numShares: 296,
    type: "STK",
    price: 4834.21,
    value: 36203.77,
    date: "2021-01-08",
  },
  {
    assetId: 608877,
    ticker: "CSPI",
    numShares: 467,
    type: "STK",
    price: 2803.14,
    value: 2297.44,
    date: "2021-01-05",
  },
  {
    assetId: 807020,
    ticker: "RNVA",
    numShares: 28,
    type: "STK",
    price: 4579.94,
    value: 10351.05,
    date: "2021-01-28",
  },
  {
    assetId: 223246,
    ticker: "EXR",
    numShares: 32,
    type: "STK",
    price: 4948.29,
    value: 32777.95,
    date: "2021-01-26",
  },
  {
    assetId: 698834,
    ticker: "EFAS",
    numShares: 251,
    type: "STK",
    price: 911.79,
    value: 7637.93,
    date: "2021-01-27",
  },
  {
    assetId: 730182,
    ticker: "DFT^C",
    numShares: 417,
    type: "STK",
    price: 948.33,
    value: 45165.51,
    date: "2021-01-22",
  },
  {
    assetId: 361877,
    ticker: "TNP^C",
    numShares: 396,
    type: "STK",
    price: 2531.17,
    value: 10263.6,
    date: "2021-01-24",
  },
  {
    assetId: 103257,
    ticker: "DHI",
    numShares: 304,
    type: "STK",
    price: 2710.41,
    value: 25177.32,
    date: "2021-01-24",
  },
  {
    assetId: 297405,
    ticker: "FIF",
    numShares: 3,
    type: "STK",
    price: 4758.51,
    value: 21084.81,
    date: "2021-01-24",
  },
  {
    assetId: 226262,
    ticker: "NEA",
    numShares: 469,
    type: "STK",
    price: 3152.24,
    value: 32292.31,
    date: "2021-01-26",
  },
  {
    assetId: 886498,
    ticker: "LCAHU",
    numShares: 168,
    type: "STK",
    price: 3704.7,
    value: 842.25,
    date: "2021-01-20",
  },
  {
    assetId: 379466,
    ticker: "RTTR",
    numShares: 492,
    type: "STK",
    price: 4137.55,
    value: 11262.89,
    date: "2021-01-27",
  },
  {
    assetId: 948342,
    ticker: "STN",
    numShares: 33,
    type: "STK",
    price: 3818.73,
    value: 34077.66,
    date: "2021-01-04",
  },
  {
    assetId: 950319,
    ticker: "AEG",
    numShares: 444,
    type: "STK",
    price: 1108.09,
    value: 36738.35,
    date: "2021-01-13",
  },
  {
    assetId: 620491,
    ticker: "ICCC",
    numShares: 391,
    type: "STK",
    price: 463.74,
    value: 42887.48,
    date: "2021-01-29",
  },
  {
    assetId: 560571,
    ticker: "NEWTL",
    numShares: 213,
    type: "STK",
    price: 3378.6,
    value: 35733.29,
    date: "2021-01-19",
  },
  {
    assetId: 616573,
    ticker: "RACE",
    numShares: 26,
    type: "STK",
    price: 2779.04,
    value: 33826.62,
    date: "2021-01-15",
  },
  {
    assetId: 659785,
    ticker: "MITK",
    numShares: 183,
    type: "STK",
    price: 1581.93,
    value: 42006.94,
    date: "2021-01-30",
  },
  {
    assetId: 820496,
    ticker: "BFAM",
    numShares: 454,
    type: "STK",
    price: 1861.74,
    value: 19826.93,
    date: "2021-01-25",
  },
  {
    assetId: 632466,
    ticker: "L",
    numShares: 12,
    type: "STK",
    price: 1112.7,
    value: 39977.47,
    date: "2021-01-16",
  },
  {
    assetId: 578009,
    ticker: "PAGP",
    numShares: 492,
    type: "STK",
    price: 4629.58,
    value: 49439.76,
    date: "2021-01-09",
  },
  {
    assetId: 378788,
    ticker: "THC",
    numShares: 206,
    type: "STK",
    price: 2137.81,
    value: 6025.07,
    date: "2021-01-03",
  },
  {
    assetId: 248516,
    ticker: "SBNA",
    numShares: 187,
    type: "STK",
    price: 604.06,
    value: 41079.16,
    date: "2021-01-08",
  },
  {
    assetId: 337924,
    ticker: "ANCB",
    numShares: 179,
    type: "STK",
    price: 1613.49,
    value: 7246.53,
    date: "2021-01-27",
  },
  {
    assetId: 850588,
    ticker: "PULM",
    numShares: 269,
    type: "STK",
    price: 2558.02,
    value: 32071.71,
    date: "2021-01-21",
  },
  {
    assetId: 569333,
    ticker: "MUR",
    numShares: 133,
    type: "STK",
    price: 4278.35,
    value: 37025.87,
    date: "2021-01-24",
  },
  {
    assetId: 201938,
    ticker: "PSCD",
    numShares: 182,
    type: "STK",
    price: 1259.96,
    value: 46898.91,
    date: "2021-01-22",
  },
  {
    assetId: 161225,
    ticker: "CPF",
    numShares: 499,
    type: "STK",
    price: 4999.15,
    value: 7526.58,
    date: "2021-01-29",
  },
  {
    assetId: 788903,
    ticker: "DCUD",
    numShares: 420,
    type: "STK",
    price: 1301.57,
    value: 38472.83,
    date: "2021-01-03",
  },
  {
    assetId: 600360,
    ticker: "SGF",
    numShares: 233,
    type: "STK",
    price: 1184.2,
    value: 24913.59,
    date: "2021-01-20",
  },
  {
    assetId: 508543,
    ticker: "SSBI",
    numShares: 404,
    type: "STK",
    price: 554.17,
    value: 8011.02,
    date: "2021-01-29",
  },
  {
    assetId: 664334,
    ticker: "TD",
    numShares: 68,
    type: "STK",
    price: 2268.37,
    value: 5582.4,
    date: "2021-01-29",
  },
  {
    assetId: 497724,
    ticker: "CNFR",
    numShares: 160,
    type: "STK",
    price: 1038.07,
    value: 39590.23,
    date: "2021-01-16",
  },
  {
    assetId: 702423,
    ticker: "FTAG",
    numShares: 17,
    type: "STK",
    price: 3208.6,
    value: 8333.1,
    date: "2021-01-21",
  },
  {
    assetId: 456217,
    ticker: "USB^O",
    numShares: 162,
    type: "STK",
    price: 2808.27,
    value: 2651.12,
    date: "2021-01-10",
  },
  {
    assetId: 705932,
    ticker: "USOI",
    numShares: 301,
    type: "STK",
    price: 778.81,
    value: 34245.38,
    date: "2021-01-25",
  },
  {
    assetId: 877340,
    ticker: "BANC^D",
    numShares: 313,
    type: "STK",
    price: 96.79,
    value: 22743.2,
    date: "2021-01-26",
  },
  {
    assetId: 907531,
    ticker: "USATP",
    numShares: 158,
    type: "STK",
    price: 2542.86,
    value: 18053.81,
    date: "2021-01-22",
  },
  {
    assetId: 833721,
    ticker: "BCTF",
    numShares: 368,
    type: "STK",
    price: 4593.63,
    value: 10174.42,
    date: "2021-01-03",
  },
  {
    assetId: 925897,
    ticker: "CORE",
    numShares: 391,
    type: "STK",
    price: 2661.82,
    value: 10404.45,
    date: "2021-01-05",
  },
  {
    assetId: 160505,
    ticker: "TOPS",
    numShares: 36,
    type: "STK",
    price: 3601.28,
    value: 14702.94,
    date: "2021-01-13",
  },
  {
    assetId: 802068,
    ticker: "JAX",
    numShares: 16,
    type: "STK",
    price: 2027.13,
    value: 6665.84,
    date: "2021-01-06",
  },
  {
    assetId: 143341,
    ticker: "OMED",
    numShares: 133,
    type: "STK",
    price: 2707.88,
    value: 46564.94,
    date: "2021-01-26",
  },
  {
    assetId: 555882,
    ticker: "FSCFL",
    numShares: 113,
    type: "STK",
    price: 23.75,
    value: 16809.03,
    date: "2021-01-26",
  },
  {
    assetId: 329407,
    ticker: "PMT",
    numShares: 123,
    type: "STK",
    price: 2600.79,
    value: 41731.37,
    date: "2021-01-15",
  },
  {
    assetId: 106368,
    ticker: "FDS",
    numShares: 293,
    type: "STK",
    price: 3845.68,
    value: 409.59,
    date: "2021-01-26",
  },
  {
    assetId: 721609,
    ticker: "IVFVC",
    numShares: 322,
    type: "STK",
    price: 1164.44,
    value: 24311.93,
    date: "2021-01-22",
  },
  {
    assetId: 823315,
    ticker: "KTEC",
    numShares: 414,
    type: "STK",
    price: 3436.33,
    value: 5916.75,
    date: "2021-01-11",
  },
  {
    assetId: 924470,
    ticker: "HGSH",
    numShares: 234,
    type: "STK",
    price: 339.87,
    value: 38949.81,
    date: "2021-01-11",
  },
  {
    assetId: 429998,
    ticker: "ALDR",
    numShares: 410,
    type: "STK",
    price: 3705.61,
    value: 16366.29,
    date: "2021-01-03",
  },
  {
    assetId: 701041,
    ticker: "BMI",
    numShares: 136,
    type: "STK",
    price: 4839.62,
    value: 8121.73,
    date: "2021-01-30",
  },
  {
    assetId: 342500,
    ticker: "HSC",
    numShares: 488,
    type: "STK",
    price: 3451.06,
    value: 20869.18,
    date: "2021-01-01",
  },
  {
    assetId: 264769,
    ticker: "ATVI",
    numShares: 284,
    type: "STK",
    price: 1771.64,
    value: 28718.52,
    date: "2021-01-15",
  },
  {
    assetId: 693426,
    ticker: "JJSF",
    numShares: 237,
    type: "STK",
    price: 1455.52,
    value: 8919.44,
    date: "2021-01-03",
  },
  {
    assetId: 504687,
    ticker: "ITUB",
    numShares: 308,
    type: "STK",
    price: 4011.07,
    value: 40795.21,
    date: "2021-01-01",
  },
  {
    assetId: 836514,
    ticker: "SCAC",
    numShares: 150,
    type: "STK",
    price: 4912.76,
    value: 23522.25,
    date: "2021-01-19",
  },
  {
    assetId: 196962,
    ticker: "CBL^D",
    numShares: 476,
    type: "STK",
    price: 4694.04,
    value: 30155.36,
    date: "2021-01-04",
  },
  {
    assetId: 710842,
    ticker: "AAXJ",
    numShares: 216,
    type: "STK",
    price: 4894.49,
    value: 2467.15,
    date: "2021-01-16",
  },
  {
    assetId: 579267,
    ticker: "FEM",
    numShares: 101,
    type: "STK",
    price: 2119.17,
    value: 20730.08,
    date: "2021-01-01",
  },
  {
    assetId: 787071,
    ticker: "LCII",
    numShares: 289,
    type: "STK",
    price: 736.43,
    value: 39837.26,
    date: "2021-01-08",
  },
  {
    assetId: 675232,
    ticker: "DSL",
    numShares: 265,
    type: "STK",
    price: 150.91,
    value: 10351.01,
    date: "2021-01-18",
  },
  {
    assetId: 369810,
    ticker: "AHGP",
    numShares: 229,
    type: "STK",
    price: 1864.54,
    value: 33821.86,
    date: "2021-01-14",
  },
  {
    assetId: 991317,
    ticker: "NQP",
    numShares: 225,
    type: "STK",
    price: 1359.23,
    value: 24851.87,
    date: "2021-01-29",
  },
  {
    assetId: 371012,
    ticker: "MOV",
    numShares: 396,
    type: "STK",
    price: 997.79,
    value: 46165.06,
    date: "2021-01-28",
  },
  {
    assetId: 481249,
    ticker: "EVF",
    numShares: 311,
    type: "STK",
    price: 2919.35,
    value: 41905.18,
    date: "2021-01-13",
  },
  {
    assetId: 753809,
    ticker: "CPT",
    numShares: 29,
    type: "STK",
    price: 951.92,
    value: 29644.74,
    date: "2021-01-24",
  },
  {
    assetId: 938409,
    ticker: "FLIR",
    numShares: 57,
    type: "STK",
    price: 3351.58,
    value: 37080.3,
    date: "2021-01-15",
  },
  {
    assetId: 499991,
    ticker: "TNC",
    numShares: 360,
    type: "STK",
    price: 3115.18,
    value: 16074.57,
    date: "2021-01-25",
  },
  {
    assetId: 904060,
    ticker: "STOR",
    numShares: 84,
    type: "STK",
    price: 2173.55,
    value: 6498.94,
    date: "2021-01-27",
  },
  {
    assetId: 416745,
    ticker: "SREV",
    numShares: 32,
    type: "STK",
    price: 45.79,
    value: 39869.21,
    date: "2021-01-17",
  },
  {
    assetId: 639572,
    ticker: "IMMR",
    numShares: 355,
    type: "STK",
    price: 1537.12,
    value: 10956.34,
    date: "2021-01-22",
  },
  {
    assetId: 850828,
    ticker: "LILA",
    numShares: 5,
    type: "STK",
    price: 4651.87,
    value: 4810.22,
    date: "2021-01-20",
  },
  {
    assetId: 952093,
    ticker: "NMY",
    numShares: 213,
    type: "STK",
    price: 1049.09,
    value: 41792.48,
    date: "2021-01-26",
  },
  {
    assetId: 152693,
    ticker: "JVA",
    numShares: 421,
    type: "STK",
    price: 43.84,
    value: 1443.13,
    date: "2021-01-20",
  },
  {
    assetId: 606967,
    ticker: "SCACU",
    numShares: 169,
    type: "STK",
    price: 4777.48,
    value: 26125.8,
    date: "2021-01-04",
  },
  {
    assetId: 533891,
    ticker: "NAV^D",
    numShares: 415,
    type: "STK",
    price: 4404.92,
    value: 31359.62,
    date: "2021-01-01",
  },
  {
    assetId: 180012,
    ticker: "QYLD",
    numShares: 436,
    type: "STK",
    price: 3409.23,
    value: 431.38,
    date: "2021-01-06",
  },
  {
    assetId: 381437,
    ticker: "DFBG",
    numShares: 109,
    type: "STK",
    price: 2177.43,
    value: 37955.81,
    date: "2021-01-11",
  },
  {
    assetId: 921457,
    ticker: "SYBT",
    numShares: 485,
    type: "STK",
    price: 813.86,
    value: 6155.92,
    date: "2021-01-12",
  },
  {
    assetId: 257804,
    ticker: "NEWR",
    numShares: 388,
    type: "STK",
    price: 2584.27,
    value: 1977.03,
    date: "2021-01-23",
  },
  {
    assetId: 408642,
    ticker: "BBRY",
    numShares: 162,
    type: "STK",
    price: 914.82,
    value: 49096.0,
    date: "2021-01-14",
  },
  {
    assetId: 940019,
    ticker: "PVTBP",
    numShares: 7,
    type: "STK",
    price: 4832.14,
    value: 32445.2,
    date: "2021-01-27",
  },
  {
    assetId: 422137,
    ticker: "MFG",
    numShares: 71,
    type: "STK",
    price: 3558.44,
    value: 47393.74,
    date: "2021-01-30",
  },
  {
    assetId: 385941,
    ticker: "ZB^A",
    numShares: 183,
    type: "STK",
    price: 336.35,
    value: 1255.46,
    date: "2021-01-16",
  },
  {
    assetId: 755563,
    ticker: "HT^E",
    numShares: 240,
    type: "STK",
    price: 4560.28,
    value: 44577.13,
    date: "2021-01-11",
  },
  {
    assetId: 105218,
    ticker: "ATXI",
    numShares: 464,
    type: "STK",
    price: 3177.39,
    value: 1479.31,
    date: "2021-01-26",
  },
  {
    assetId: 520391,
    ticker: "VMO",
    numShares: 444,
    type: "STK",
    price: 2704.01,
    value: 30198.99,
    date: "2021-01-05",
  },
  {
    assetId: 978237,
    ticker: "PK",
    numShares: 434,
    type: "STK",
    price: 4213.84,
    value: 46818.45,
    date: "2021-01-06",
  },
  {
    assetId: 432776,
    ticker: "VTR",
    numShares: 68,
    type: "STK",
    price: 492.6,
    value: 15919.65,
    date: "2021-01-04",
  },
  {
    assetId: 584691,
    ticker: "HIFR",
    numShares: 195,
    type: "STK",
    price: 2564.03,
    value: 30730.84,
    date: "2021-01-02",
  },
  {
    assetId: 312523,
    ticker: "ENH^C",
    numShares: 222,
    type: "STK",
    price: 2071.6,
    value: 31472.16,
    date: "2021-01-10",
  },
  {
    assetId: 125982,
    ticker: "BELFB",
    numShares: 417,
    type: "STK",
    price: 2526.37,
    value: 39750.28,
    date: "2021-01-16",
  },
  {
    assetId: 115761,
    ticker: "MDXG",
    numShares: 58,
    type: "STK",
    price: 1676.64,
    value: 35796.99,
    date: "2021-01-18",
  },
  {
    assetId: 730088,
    ticker: "ATHN",
    numShares: 320,
    type: "STK",
    price: 2820.17,
    value: 34070.4,
    date: "2021-01-05",
  },
  {
    assetId: 667451,
    ticker: "I",
    numShares: 398,
    type: "STK",
    price: 2350.36,
    value: 27454.25,
    date: "2021-01-21",
  },
  {
    assetId: 741234,
    ticker: "ATHX",
    numShares: 191,
    type: "STK",
    price: 4827.99,
    value: 38977.89,
    date: "2021-01-07",
  },
  {
    assetId: 838395,
    ticker: "SCON",
    numShares: 305,
    type: "STK",
    price: 2351.07,
    value: 13783.87,
    date: "2021-01-08",
  },
  {
    assetId: 488304,
    ticker: "NUS",
    numShares: 334,
    type: "STK",
    price: 3021.4,
    value: 2320.43,
    date: "2021-01-21",
  },
  {
    assetId: 920127,
    ticker: "MYOS",
    numShares: 258,
    type: "STK",
    price: 3972.37,
    value: 46275.79,
    date: "2021-01-24",
  },
  {
    assetId: 948643,
    ticker: "ALX",
    numShares: 170,
    type: "STK",
    price: 3449.09,
    value: 5606.41,
    date: "2021-01-22",
  },
  {
    assetId: 549852,
    ticker: "IMPV",
    numShares: 305,
    type: "STK",
    price: 2890.73,
    value: 7316.36,
    date: "2021-01-12",
  },
  {
    assetId: 235717,
    ticker: "ARI^C",
    numShares: 87,
    type: "STK",
    price: 3077.43,
    value: 25689.54,
    date: "2021-01-19",
  },
  {
    assetId: 929848,
    ticker: "BDJ",
    numShares: 433,
    type: "STK",
    price: 4266.5,
    value: 6839.38,
    date: "2021-01-15",
  },
  {
    assetId: 105036,
    ticker: "ECYT",
    numShares: 75,
    type: "STK",
    price: 1968.79,
    value: 10289.98,
    date: "2021-01-28",
  },
  {
    assetId: 681671,
    ticker: "MAV",
    numShares: 459,
    type: "STK",
    price: 2895.21,
    value: 32424.42,
    date: "2021-01-19",
  },
  {
    assetId: 600359,
    ticker: "SCWX",
    numShares: 119,
    type: "STK",
    price: 2556.64,
    value: 28664.48,
    date: "2021-01-28",
  },
  {
    assetId: 772082,
    ticker: "VJET",
    numShares: 482,
    type: "STK",
    price: 1977.6,
    value: 3928.4,
    date: "2021-01-06",
  },
];
